import React, { useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import { Box } from '@chakra-ui/react';
import { dataLayerVideos } from '@helpers/dataLayerPush';

/**
 * Returns seconds in time
 * @param {number} string in seconds
 * @returns {number} in seconds
 */
function pad(string) {
  return `0${string}`.slice(-2);
}

/**
 * Returns mins and seconds from a  total seconds
 * @param {number} seconds number in seconds
 * @returns {number} time in mins and seconds
 */
function format(seconds) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}

const ResponsivePlayer = ({ url }) => {
  const [played, setPlayed] = useState(0);
  const [duration, setDuration] = useState(0);

  return (
    <Box position="relative" paddingTop="56.25%">
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        style={{
          position: `absolute`,
          top: 0,
          left: 0
        }}
        // Added the Loaded datalayer push in here as the
        // onReady fired before the duration was calculated.
        onDuration={(length) => {
          setDuration(length);
          dataLayerVideos({
            event: `videos`,
            url,
            status: `Loaded`,
            percentage: `0%`,
            duration: format(length)
          });
        }}
        onProgress={(progress) => {
          setPlayed(progress.playedSeconds);
        }}
        onPlay={() => {
          dataLayerVideos({
            event: `videos`,
            url,
            status: `Play`,
            percentage: `${Math.round((played / duration) * 100)}%`,
            duration: format(duration)
          });
        }}
        onPause={() => {
          dataLayerVideos({
            event: `videos`,
            url,
            status: `Pause`,
            percentage: `${Math.round((played / duration) * 100)}%`,
            duration: format(duration)
          });
        }}
        onSeek={() => {
          dataLayerVideos({
            event: `videos`,
            url,
            status: `Seek`,
            percentage: `${Math.round((played / duration) * 100)}%`,
            duration: format(duration)
          });
        }}
        config={{
          youtube: {
            embedOptions: {
              host: `https://www.youtube-nocookie.com`
            }
          }
        }}
      />
    </Box>
  );
};

export default ResponsivePlayer;
